import { Directive, Input, TemplateRef, inject } from '@angular/core'

@Directive({
    selector: 'ng-template[appTypedTemplate]',
    standalone: true,
})
export class TypedTemplateDirective<TypeToken> {
    private contentTemplate = inject<TemplateRef<TypeToken>>(TemplateRef)

    @Input('appTypedTemplate') typeToken!: TypeToken

    static ngTemplateContextGuard<TypeToken>(
        dir: TypedTemplateDirective<TypeToken>,
        ctx: unknown,
    ): ctx is TypeToken {
        return true
    }
}
